import {
	setHeroComponentAnimationDirection,
	addConversationCardToHero,
	moveQuickLinksFromHeroToBody,
} from '../../../../design3/asset-build/js/custom/fullscreenHero';

import {
	triggerLinkView,
	trackClickUsingCapture,
	campaignTrackChildren,
} from '../../../../design3/asset-build/js/analytics/analytics';

import { getStore } from '../../../../design3/asset-build/js/custom/stores';
import { autorun } from 'mobx';

const qs = Object.fromEntries(new URLSearchParams(window.location.search).entries());
// SHOPPING STATE EXAMPLE
// const state = {
// 	owsCode: 'HKG581',
// 	mostRecentSearch: {
// 		rooms: [{ offer_code: '', bed_code: '', children: 0, adults: 2 }],
// 		checkin: '2022-06-14',
// 		checkout: '2022-06-15',
// 		timestamp: '2022-05-04+18:46:15.197',
// 	},
// 	reservations: [{ timestamp: '2022-05-02+20:35:42.276' }],
// 	journeyStage: 'SHOPPING',
// 	mostRecentlyViewed: {
// 		section: 'landing',
// 		url: 'https://www.qa.stage.fsweb.ca/hongkong/',
// 		timestamp: '2022-05-04+18:45:25.109',
// 	}
// }

const getJourneyAwarenessActions = () => [
	{
		stages: ['PLANNING'], //'DISCOVERY', 'PLANNING', 'SHOPPING'
		action: threeCardLink,
		enabled: window.FS.propertyInfo && window.FS.propertyInfo.isPlp && !qs.ppc,
		delayHeroEmit: false,
	},
	{
		stages: ['SHOPPING'], //'DISCOVERY', 'PLANNING', 'SHOPPING'
		action: lwcStatusesSummary,
		enabled: window.FS.propertyInfo && window.FS.propertyInfo.isPlp && !qs.ppc,
		delayHeroEmit: false,
	},
	{
		stages: ['PLANNING', 'SHOPPING'], //'DISCOVERY', 'PLANNING', 'SHOPPING'
		action: conversationCard,
		enabled:
			window.FS.propertyInfo &&
			window.FS.propertyInfo.owsCode &&
			window.FS.propertyInfo.isPlp &&
			!qs.ppc,
		delayHeroEmit: true,
	},
];
let tileName = 'no state found';
let cookie = 'no value';
let delayHeroEmit = false;
export default async function journeyAwareness() {
	if (window.FS.DECISION_ENGINE && window.FS.propertyInfo && window.FS.propertyInfo.owsCode) {
		//get the state
		const state = await window.FS.DECISION_ENGINE.getState(window.FS.propertyInfo.owsCode);
		window.journeyStage = state && state.journeyStage ? state.journeyStage : 'no stage found';

		// setup tracking
		if (state && state.journeyStage === 'DISCOVERY') {
			tileName = 'first time visitor';
		} else if (state && state.journeyStage === 'PLANNING') {
			tileName = 'return visitor';
		} else if (state && state.journeyStage === 'SHOPPING') {
			tileName = 'resume search';
		} else if (state && state.journeyStage) {
			tileName = state.journeyStage;
		}
		cookie = window.FS.DECISION_ENGINE.getCookie() || 'no value';
		if (window.FS.propertyInfo.isPlp === true) {
			triggerLinkView('ja_impression', {
				ja_stage: state && state.journeyStage ? state.journeyStage.toLowerCase() : 'no stage found',
				ja_tile_name: tileName,
				ja_cookie: cookie,
			});
		}
		campaignTrackChildren(
			document.querySelector('.QuickLinks--hero'),
			`ja_${utag_data.property_code}_hero_${tileName}`
		);
		campaignTrackChildren(
			document.querySelectorAll('.IconTextLinks'),
			`ja_${utag_data.property_code}_lwc_${tileName}`
		);
		if (state && state.journeyStage) {
			try {
				const promises = [];
				getJourneyAwarenessActions().forEach(comp => {
					if (comp.enabled && comp.stages.includes(state.journeyStage)) {
						promises.push(comp.action(state));
						delayHeroEmit = delayHeroEmit || comp.delayHeroEmit;
					}
				});
				await Promise.allSettled(promises);
			} catch (e) {}
		}
	}
	if (!delayHeroEmit) {
		emitHeroEvent();
	}
}

const emitHeroEvent = () => $(window).trigger('beginHeroComponentAnimation');

const getPageLanguage = () => document.querySelector('body').dataset.language || 'en';

const getOnPageTwoCardLinkComponent = () => {
	const comps = document.querySelectorAll('.IconTextLinks');
	let twoCardLinkComponent;
	comps.forEach(comp => {
		if (
			!twoCardLinkComponent &&
			comp.querySelectorAll('.IconTextLinks-link--column').length === 2
		) {
			twoCardLinkComponent = comp;
		}
	});
	return twoCardLinkComponent;
};

const getThreeCardLinkComponent = async state => {
	const iconAndTextLinksResult = await fetch('/alt/apps/fshr/design3/render-component', {
		method: 'POST',
		body: new URLSearchParams({
			resourceType: 'fshr/property/primitives/journey-aware-three-link-cards',
			model: JSON.stringify(Object.assign({ propertyPath: window.FS.propertyInfo.path }, state)),
			translate: JSON.stringify({
				language: getPageLanguage(),
			}),
		}),
	});
	if (iconAndTextLinksResult.status === 200) {
		return await iconAndTextLinksResult.text();
	}
};

const threeCardLink = async state => {
	try {
		const twoCardLinkComponent = getOnPageTwoCardLinkComponent();
		if (twoCardLinkComponent) {
			const iconAndTextLinksHTML = await getThreeCardLinkComponent(state);
			if (iconAndTextLinksHTML) {
				twoCardLinkComponent.insertAdjacentHTML('beforebegin', iconAndTextLinksHTML);
				trackClickUsingCapture(twoCardLinkComponent.previousSibling, 'ja_click', {
					ja_stage: state.journeyStage.toLowerCase(),
					ja_tile_name: `${tileName}:lwc three card links`,
					ja_cookie: cookie,
				});
				campaignTrackChildren(
					twoCardLinkComponent.previousSibling,
					`ja_${utag_data.property_code}_lwc three card links_${tileName}`
				);
				twoCardLinkComponent.remove();
			}
		}
	} catch (e) {
		//failed somewhere
		console.error('error building three card link', e);
	}
};

const getLWCStatusesSummaryComponent = async state => {
	const lwcStatusesSummaryResult = await fetch('/alt/apps/fshr/design3/render-component', {
		method: 'POST',
		body: new URLSearchParams({
			resourceType: 'fshr/property/primitives/journey-aware-lwc-statuses',
			model: JSON.stringify(Object.assign({ propertyPath: window.FS.propertyInfo.path }, state)),
			translate: JSON.stringify({
				language: getPageLanguage(),
			}),
		}),
	});
	if (lwcStatusesSummaryResult.status === 200) {
		return await lwcStatusesSummaryResult.text();
	}
};

const lwcStatusesSummary = async state => {
	try {
		const twoCardLinkComponent = getOnPageTwoCardLinkComponent();
		if (twoCardLinkComponent) {
			const lwcStatusesHTML = await getLWCStatusesSummaryComponent(state);
			if (lwcStatusesHTML) {
				twoCardLinkComponent.insertAdjacentHTML('afterend', lwcStatusesHTML);
				trackClickUsingCapture(twoCardLinkComponent.nextSibling, 'ja_click', {
					ja_stage: state.journeyStage.toLowerCase(),
					ja_tile_name: `${tileName}:lwc statuses summary`,
					ja_cookie: cookie,
				});
				campaignTrackChildren(
					twoCardLinkComponent.nextSibling,
					`ja_${utag_data.property_code}_lwc statuses summary_${tileName}`
				);
			}
		}
	} catch (e) {
		//failed somewhere
		console.error('error building lwc statuses', e);
	}
};

const conversationCard = async state => {
	try {
		const planStore = await getStore('planStore');

		autorun(async () => {
			const embeddedBookingEnabled = await planStore.embeddedBookingEnabled(
				window.FS.propertyInfo.owsCode
			);

			if (!(window.FS.propertyInfo.disableBooking && state && state.journeyStage === 'SHOPPING')) {
				const conversationCardRes = await fetch('/alt/apps/fshr/design3/render-component', {
					method: 'POST',
					body: new URLSearchParams({
						resourceType: 'fshr/property/primitives/journey-aware-conversation-card',
						model: JSON.stringify(
							Object.assign(
								{},
								{
									owsCode: window.FS.propertyInfo.owsCode,
									propertyPath: window.FS.propertyInfo.path,
									embeddedBookingEnabled,
									disableBooking: window.FS.propertyInfo.disableBooking,
								},
								state
							)
						),
						translate: JSON.stringify({
							language: getPageLanguage(),
						}),
						context: JSON.stringify({
							inFullscreenHero: true,
						}),
					}),
				});

				if (conversationCardRes.status === 200) {
					const conversationCard = await conversationCardRes.text();

					if (conversationCard) {
						//move the  Quick Links from the hero to the body
						moveQuickLinksFromHeroToBody({
							ensureBodySectionTopSpacing: true,
							deleteFromHero: true,
						});

						//add it to the hero
						const fullscreenHero = addConversationCardToHero({ cardHtml: conversationCard });
						setHeroComponentAnimationDirection('bottom');
						if (embeddedBookingEnabled) {
							$('.ConversationCard-cawTrigger').on('click', e => {
								e.preventDefault();
								window.dispatchEvent(
									new CustomEvent('cawComponentOpen', { detail: { setFocusTo: 'dates' } })
								);
							});
						}
						if (fullscreenHero) {
							const conversationCards = Array.from(
								document.querySelectorAll('.ConversationCard-heroWrapper')
							);
							trackClickUsingCapture(conversationCards, 'ja_click', {
								ja_stage: state.journeyStage.toLowerCase(),
								ja_tile_name: `${tileName}:hero`,
								ja_cookie: cookie,
							});
							campaignTrackChildren(
								conversationCards,
								`ja_${utag_data.property_code}_hero_${tileName}`
							);
							campaignTrackChildren(
								document.querySelector('.QuickLinks--body'),
								`ja_${utag_data.property_code}_hero_${tileName}`
							);
						}
					}
				}
			}
			emitHeroEvent();
		});
	} catch (e) {
		//failed somewhere
		console.error('error building conversations card', e);
	}
};
